import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {Subject, takeUntil} from 'rxjs';
import {
  EditSurveyResponseRequest,
  FetchSurveyResponseForReviewAndEditForSuperAdminRequest
} from '../../core/questionnaires.actions';
import {
  fetchSurveyResponseForReviewForAdmins
} from '../../core/questionnaires.selectors';
import {
  SurveyReviewDetails
} from '../../models/fetch-questionnaires-list.model';
import {Model} from "survey-core";
import {CommonService} from "../../../../shared/services/common.service";
import {profile} from 'src/app/modules/shared/core/shared.selectors';
import {QuestionnairesService} from "../../core/questionnaires.service";

@Component({
  selector: 'app-review-survey-response-screen',
  templateUrl: './review-survey-response-screen.component.html',
  styleUrls: ['./review-survey-response-screen.component.css']
})
export class ReviewSurveyResponseScreenComponent {
  surveyDetails: SurveyReviewDetails;
  mode: string = 'view'
  surveyModel: Model;
  loggedInUserRole: number = null;
  groupId: string = ''
  clientId: string = '';
  loading: boolean = false;
  private surveyId: string = ''
  private userId: string = ''
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private roleMap = {
    1: 'stanford-admin',
    2: 'organization-admin',
    3: 'coach',
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private commonService: CommonService,
    private questionnairesService: QuestionnairesService
  ) {
  }


  ngOnInit(): void {
    this.store.select(profile).pipe(takeUntil(this.onDestroy))
      .subscribe(profile => {
        if(profile){
          this.loggedInUserRole = profile.role;
        }
      })
    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        if (params?.params?.questionnaireId && params.params.userId) {
          this.surveyId = params?.params?.questionnaireId
          this.userId = params.params.userId
          this.store.dispatch(FetchSurveyResponseForReviewAndEditForSuperAdminRequest({payload: {surveyId: params?.params?.questionnaireId, userId: params.params.userId}}))
        }
        if (params.params.groupId) {
          this.groupId = params.params.groupId
        }
        if (params.params.clientId) {
          this.clientId = params.params.clientId
        }
      });

    this.store.select(fetchSurveyResponseForReviewForAdmins).pipe(
      takeUntil(this.onDestroy)
    ).subscribe((reviewDetails: any) => {
      this.loading = reviewDetails.loading;
      this.surveyDetails = reviewDetails.surveyReviewDetails
    });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }
        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });

    this.questionnairesService.updateSurveyReviewMode
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.mode = data;
      });
  }

  editButtonClicked() {
    this.mode = 'edit'
    let surveyData = {
      name: 'page1',
      elements: []
    }
    let responseData = {}
    if (this?.surveyDetails?.value && this?.surveyDetails?.value[0] && this?.surveyDetails?.value[0]?.elements) {
      this?.surveyDetails?.value[0]?.elements.map(element => {
        responseData = {...responseData, [element.name]: element.value ? element.value : ''}
        let updatedData = {...element}
        delete updatedData.value
        surveyData.elements.push(updatedData)
      })
    }
    const survey = new Model(surveyData);
    survey.showCompletedPage = false;
    survey.onComplete.add((sender, options) => {
      this.submitUserResponse(survey)
    });
    survey.data = responseData;
    survey.completeText = "Save";
    survey.questionErrorLocation = 'bottom'
    this.surveyModel = survey;
  }


  submitUserResponse(survey: any) {
    // this.mode = 'view';
    const updatedElements: any[] = []
    this.surveyDetails.value[0].elements.forEach(element => {
      let matchFound: boolean = false
      let updatedElementData: any = {}
      Object.keys(survey.data).forEach((response, responseIndex: number) => {
        if (element.name === response) {
          matchFound = true
          updatedElementData = {...element, value: survey.data[response]}
        }
        if ((responseIndex === Object.keys(survey.data).length - 1) && !matchFound) {
          updatedElementData = {...element, value: ""}
        }
      })
      updatedElements.push(updatedElementData)
    })
    const updatedConfig = {...this.surveyDetails.value[0], elements: updatedElements}
    this.surveyDetails = {...this.surveyDetails, value: [updatedConfig]}
    survey.clear(false, true)
    this.store.dispatch(EditSurveyResponseRequest({
      payload: {
        surveyId: this.surveyId,
        config: [updatedConfig],
        forUserId: this.userId
      }
    }))
  }


  backButtonClicked() {
    if (this.loggedInUserRole === 1 && !this.groupId && !this.clientId) {
      this.router.navigate([`/stanford-admin/questionnaires/edit-questionnaire/${this.surveyId}`])
    } else if (this.groupId || this.clientId) {
      if (this.groupId) {
        this.router.navigate([`/${this.roleMap[this.loggedInUserRole]}/group/${this.groupId}/questionnaires/edit-questionnaire/${this.surveyId}`])
      } else if (this.clientId) {
        this.router.navigate([`/${this.roleMap[this.loggedInUserRole]}/organization/${this.clientId}/questionnaires/edit-questionnaire/${this.surveyId}`])
      }
    }
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
